const _ = require('lodash');

function SlideNavigationDirective() {
    return {
        restrict: 'E',
        template: require('./slide-navigation-template.html'),
        scope: {
            slider: '=',
            disableNext: '=?'
        },
        link(scope) {
            if (_.isUndefined(scope.disableNext)) {
               scope.disableNext = false;
            }
        }
    };
}

module.exports = SlideNavigationDirective;


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/customer-reviews/post-review/slide-navigation-directive.js
 **/